import moment from '@/plugins/moment'

const LOCALSTORAGE_KEY = 'dismissedMaintenances'

const storedDismissedMaintenance = localStorage.getItem(LOCALSTORAGE_KEY)
export const dismissedMaintenances = storedDismissedMaintenance
    ? JSON.parse(storedDismissedMaintenance)
    : []

export const currentMaintenanceDate = moment('2022-09-17T03:00:00+07')
